var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoRegister(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104 104.6",
    style: {
      enableBackground: "new 0 0 104 104.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#82D0E6;}\n\t.st1{fill:#FFFEFC;}\n\t.st2{fill:#064B93;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:none;stroke:#FEFFFF;stroke-width:0.6;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo-Register",
    transform: "translate(0.194 0.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1426",
    className: "st0",
    d: "M103.8,61.2h-104l0,0V9.9c0-5.5,4.5-10.1,10-10.1h84c5.5,0,10,4.5,10,10.1V61.2 L103.8,61.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "qr_code_2_FILL0_wght400_GRAD0_opsz48",
    className: "st1",
    d: "M56.3,92.5v-9h9v9H56.3z M47.3,83.5V61.1h9v22.4H47.3z M83.2,70.1 V52.2h9v17.9H83.2z M74.2,52.2v-9h9v9H74.2z M20.4,61.1v-9h9v9H20.4z M11.5,52.2v-9h9v9H11.5z M51.8,20.8v-9h9v9H51.8z M17.1,33.1 h15.7V17.4H17.1V33.1z M11.5,38.7V11.8h26.9v26.9H11.5z M17.1,86.9h15.7V71.2H17.1V86.9z M11.5,92.5V65.6h26.9v26.9H11.5z  M70.9,33.1h15.7V17.4H70.9V33.1z M65.3,38.7V11.8h26.9v26.9H65.3z M74.2,92.5V79.1h-9v-9h17.9v13.4h9v9H74.2z M56.3,61.1v-9h17.9 v9H56.3z M38.4,61.1v-9h-9v-9h26.9v9h-9v9H38.4z M42.8,38.7V20.8h9v9h9v9L42.8,38.7L42.8,38.7z M21.6,28.6v-6.7h6.7v6.7 C28.3,28.6,21.6,28.6,21.6,28.6z M21.6,82.4v-6.7h6.7v6.7H21.6z M75.3,28.6v-6.7H82v6.7C82,28.6,75.3,28.6,75.3,28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65.3,11.8v26.9h26.9V11.8H65.3z M86.5,33.1H70.9V17.4h15.7L86.5,33.1L86.5,33.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1425",
    className: "st2",
    d: "M-0.2,61.2h104l0,0v33.2c0,5.5-4.5,10.1-10,10.1h-84c-5.5,0-10-4.5-10-10.1L-0.2,61.2 L-0.2,61.2z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M51.4,78.1c0,1-0.2,1.9-0.5,2.7c-0.3,0.8-0.8,1.6-1.4,2.3c-0.6,0.7-1.3,1.2-2.1,1.6c-0.8,0.4-1.6,0.7-2.6,0.9 l6.5,8.8h-4L41,85.6h-4v8.8h-3.2V70.5h10.2c1,0,2,0.2,2.9,0.6s1.7,0.9,2.4,1.6c0.7,0.7,1.2,1.5,1.6,2.4S51.4,77,51.4,78.1z  M43.9,82.4c0.6,0,1.2-0.1,1.7-0.3c0.5-0.2,1-0.5,1.4-0.9c0.4-0.4,0.7-0.9,0.9-1.4c0.2-0.5,0.3-1.1,0.3-1.7s-0.1-1.2-0.3-1.7 c-0.2-0.5-0.5-1-0.9-1.4c-0.4-0.4-0.8-0.7-1.4-0.9c-0.5-0.2-1.1-0.3-1.7-0.3h-7v8.8H43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M58.4,73.7v7.2h11.7V84H58.4v7.2H71v3.1H55.2V70.5H71v3.1H58.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M51.4,78.1c0,1-0.2,1.9-0.5,2.7c-0.3,0.8-0.8,1.6-1.4,2.3c-0.6,0.7-1.3,1.2-2.1,1.6c-0.8,0.4-1.6,0.7-2.6,0.9 l6.5,8.8h-4L41,85.6h-4v8.8h-3.2V70.5h10.2c1,0,2,0.2,2.9,0.6s1.7,0.9,2.4,1.6c0.7,0.7,1.2,1.5,1.6,2.4S51.4,77,51.4,78.1z  M43.9,82.4c0.6,0,1.2-0.1,1.7-0.3c0.5-0.2,1-0.5,1.4-0.9c0.4-0.4,0.7-0.9,0.9-1.4c0.2-0.5,0.3-1.1,0.3-1.7s-0.1-1.2-0.3-1.7 c-0.2-0.5-0.5-1-0.9-1.4c-0.4-0.4-0.8-0.7-1.4-0.9c-0.5-0.2-1.1-0.3-1.7-0.3h-7v8.8H43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M58.4,73.7v7.2h11.7V84H58.4v7.2H71v3.1H55.2V70.5H71v3.1H58.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRegister);
export default __webpack_public_path__ + "static/media/Logo-Register.74352ef6320702e66e5512785f379dc9.svg";
export { ForwardRef as ReactComponent };